<iframe *ngIf="pshUrl" [src]="pshUrl" width="100%" height="100%">
  <p>Your browser does not support iframes.</p>
</iframe>
